import { ReactNode } from 'react';
import {
  Grid,
  Typography,
  G600,
  G500,
} from '@uniqkey-frontend/shared-app';

interface ISCIMIntegrationDetailProps {
  title: string;
  description?: string;
  children: ReactNode;
}

const SCIMIntegrationDetail = (props: ISCIMIntegrationDetailProps) => {
  const {
    title, description, children,
  } = props;

  return (
    <Grid container>
      <Grid item>
        <Typography variant="caption" mb={2} color={G600}>{title}</Typography>
      </Grid>
      <Grid item container alignItems="center" height={41}>
        {children}
      </Grid>
      {!!description && (
      <Grid item>
        <Typography variant="caption" mb={2} color={G500}>{description}</Typography>
      </Grid>
      )}
    </Grid>
  );
};

export default SCIMIntegrationDetail;
